import styled, { css } from 'styled-components'
import { BoxDefault } from '../../../../../../../../components/BoxContainer/styles'

export const BoxTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 37px;

  hgroup {
    h4 {
      margin: 0px;
      color: var(--text-tertiary);
      font-size: var(--font-size-ssm);
      font-weight: light;
    }
  }
`

export const BoxItems = styled.ul`
  @media (max-width: 1366px) {
    width: 1129px !important;
    flex-wrap: wrap;
    justify-content: start;
    gap: 20px;
  }
  width: max-content;
  margin: 32px auto 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
`

export const Circle = styled.i`
  display: block;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: var(--theme-primary);
`

export const Items = styled.li`
  min-width: 4rem;
  max-width: max-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  h6 {
    color: ${({ active }) =>
      active ? `var(--text-primary)` : `var(--text-disabled)`};
    font-size: var(--font-size-sm);
  }

  ${Circle} {
    background: ${({ active }) =>
      active ? `var(--theme-primary)` : `var(--text-disabled)`};
  }
`

export const Content = styled.main`
  margin-top: 16px;

  h2 {
    font-size: var(--font-size-md);
    color: var(--text-tertiary);
    font-weight: bold;
    margin-top: 40px 0;
  }

  h3 {
    display: flex;
    flex-direction: row;
    gap: 9px;
    align-items: center;
    margin: 0px 0px 16px 0px;
    span {
      font-size: var(--font-size-md);
      color: var(--text-tertiary);
      font-weight: bold;
    }
  }

  p {
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
  }

  > footer {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    div:last-child {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
`

export const GroupRadios = styled.ul`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 575px) {
    align-items: center;
    gap: 0;
  }
`

export const QuestionContent = styled(BoxDefault)`
  ${({ isAnswered }) => css`
    ${isAnswered &&
    css`
      background-color: rgb(235 184 82 / 6%);
      border-color: rgb(235 184 82 / 16%);
    `}

    main {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 16px;

      .need-help {
        min-width: 130px;
        color: var(--theme-primary);
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 3px;
        cursor: pointer;
      }
    }
  `}
`

export const BoldText = styled.p`
  font-weight: 800;
  display: inline;
`
export const BoxRange = styled.div`
  input,
  ul {
    width: 240px;
    cursor: pointer;
  }

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
  }

  input[type='range'] {
    overflow: hidden;
    height: 22px;
    appearance: none;
    margin: 10px 0;
    /* background: #c4c4c4; */
  }
  input[type='range']:focus {
    outline: none;
  }
  input[type='range']::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    border-radius: 5px;
  }
  input[type='range']::-webkit-slider-thumb {
    height: 16px;
    width: 16px;
    border-radius: 16px;
    background: #ecc67b;
    cursor: pointer;
    appearance: none;
    margin-top: -5px;
    /* box-shadow: -80px 0 0 80px #43e5f7; */
  }
  input[type='range']::-moz-range-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: #ecc67b;
    border-radius: 5px;
  }
  input[type='range']::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 0px solid #000000;
    height: 16px;
    width: 16px;
    border-radius: 16px;
    background: #be9137;
    cursor: pointer;
  }
  input[type='range']::-ms-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    animation-duration: 0.2s;
  }
  input[type='range']::-ms-fill-lower,
  input[type='range']::-ms-fill-upper {
    border-radius: 10px;
  }
  input[type='range']::-ms-thumb {
    margin-top: 1px;
    height: 16px;
    width: 16px;
    border-radius: 16px;
    cursor: pointer;
  }

  /* input[type='range'] {
    overflow: hidden;
    width: 80px;
    appearance: none;
    background-color: #9a905d;
  }

  input[type='range']::-webkit-slider-runnable-track {
    height: 10px;
    appearance: none;
    color: #13bba4;
    margin-top: -1px;
  }

  input[type='range']::-webkit-slider-thumb {
    width: 10px;
    appearance: none;
    height: 10px;
    cursor: ew-resize;
    background: #434343;
    box-shadow: -80px 0 0 80px #43e5f7;
  } */
`

export const Notice = styled(BoxDefault)`
  display: ${({ open }) => (open ? 'block' : 'none')};

  h2 {
    color: var(--theme-primary);
    font-size: var(--font-size-sm);
    font-weight: bold;
    margin-bottom: 32px;
  }

  p {
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
    margin-bottom: 20px;
  }

  footer {
    display: flex;
    justify-content: flex-end;
  }
`

export const BoxSelect = styled.div`
  ${({ fullWidth }) => css`
    margin-top: 10px;
    min-width: max-content;
    max-width: ${fullWidth ? '100%' : '20rem'};

    h4 {
      font-size: var(--font-size-sm);
      color: var(--text-tertiary);
      margin-bottom: 16px;
    }
  `}
`

export const BoxStar = styled.div`
  margin-top: 10px;

  h4 {
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
    margin-bottom: 16px;
  }
`
